import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SettingsIcon from "@mui/icons-material/Settings";
import { updateFormConfigs, updateThemeConfig } from "../actions";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
  },
  button: {
    backgroundColor: "var(--primary-color)",
    color: "var(--accent-color)",
    fontFamily: "var(--font-family)",
    margin: " 0 5px",
    "& .MuiButtonBase-root.MuiButton-contained:hover": {
      backgroundColor: "var(--primary-color) !important",
    },
  },
  settingButton: {
    position: "absolute",
    top: "-25px",
    zIndex: "1",
    right: "-25px",
  },
}));
function FormPaging() {
  const { theme_config, pages, current_page, previewForm } = useSelector(
    (state) => ({
      theme_config: state.theme_config,
      pages: state.pages,
      current_page: state.current_page,
      previewForm: state.previewForm,
    })
  );
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  return (
    <>
      {Object.keys(pages).length > 1 && (
        <Grid
          container
          justifyContent={
            theme_config.position_pagination === "left"
              ? "flex-start"
              : theme_config.position_pagination === "center"
              ? "center"
              : "flex-end"
          }
        >
          <Grid item classes={{ root: classes.container }}>
            {!previewForm && (
              <IconButton
                color="primary"
                className={classes.settingButton}
                onClick={handleClickOpen}
              >
                <SettingsIcon />
              </IconButton>
            )}
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>{"Footer Setting"}</DialogTitle>
              <DialogContent>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={theme_config.show_powered_btn == "1"}
                        onChange={(e) => {
                          if (e.target.checked) {
                            dispatch(
                              updateThemeConfig("show_powered_btn", "1")
                            );
                          } else {
                            dispatch(
                              updateThemeConfig("show_powered_btn", "0")
                            );
                          }
                        }}
                      />
                    }
                    label="Show button power by RTA"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControl fullWidth={true}>
                    <InputLabel>Position form paging button</InputLabel>
                    <Select
                      defaultValue={"right"}
                      value={theme_config.position_pagination}
                      onChange={(e) => {
                        dispatch(
                          updateThemeConfig(
                            "position_pagination",
                            e.target.value
                          )
                        );
                      }}
                      // label={props.field.name}
                    >
                      {["left", "right", "center"].map((option) => {
                        return <MenuItem value={option}>{option}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </FormGroup>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
            <Button
              disabled={current_page == "1"}
              className={classes.button}
              variant="contained"
            >
              <KeyboardArrowLeftIcon />
            </Button>
            <Button
              disabled={current_page == Object.keys(pages).length}
              className={classes.button}
              variant="contained"
            >
              <KeyboardArrowRightIcon />
            </Button>
            {theme_config.show_powered_btn == "1" && (
              <Button className={classes.button} variant="contained">
                Powered by RTA
              </Button>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default FormPaging;
